import React from 'react';

export const CELL = {
  present: { code: 'P', cls: 'bg-emerald-100 text-emerald-800', label: 'Present' },
  late: { code: 'L', cls: 'bg-rose-100 text-rose-700', label: 'Late' },
  early: { code: 'E', cls: 'bg-yellow-100 text-yellow-800', label: 'Left early' },
  missed: { code: 'M', cls: 'bg-orange-100 text-orange-800', label: 'Missed check-out' },
  pending: { code: 'PE', cls: 'bg-sky-100 text-sky-800', label: 'Pending approval' },
  rejected: { code: 'R', cls: 'bg-red-200 text-red-800', label: 'Rejected' },
  absent: { code: 'A', cls: 'bg-gray-100 text-gray-500', label: 'Absent' },
  off: { code: 'WO', cls: 'bg-slate-200 text-slate-500', label: 'Weekly off' },
  future: { code: '', cls: 'bg-white', label: '' },
  auto_closed: { code: 'AC', cls: 'bg-violet-100 text-violet-800', label: 'Driver auto-closed at 12 AM' },
  contact_hr: { code: 'HR', cls: 'bg-red-100 text-red-700', label: 'Driver auto-closed without location — Contact HR' },
};
const WD = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const TOTALS = [['present', 'P'], ['absent', 'A'], ['late', 'L'], ['early', 'E'], ['missed', 'M'], ['off_site', 'OS'], ['hours', 'Hrs']];

const tip = (d) => [d.date, CELL[d.status]?.label, d.hours ? `${d.hours} h` : '', d.sessions > 1 ? `${d.sessions} sessions` : '', d.late_min ? `late ${d.late_min} min` : '',
  d.early_min ? `left ${d.early_min} min early` : '', d.off_site ? 'off-site check-in' : '', d.deployed_to ? `worked in ${d.deployed_to}` : ''].filter(Boolean).join(' · ');

const Cell = ({ d, sid }) => {
  const c = CELL[d.status] || CELL.absent;
  return (
    <td className="p-0.5" title={tip(d)}>
      <div className={`relative h-8 min-w-[30px] rounded-md flex items-center justify-center text-[11px] font-bold ${c.cls}`} data-testid={`monthly-cell-${sid}-${d.date.slice(8)}`}>
        {c.code}{d.off_site && <span className="absolute -top-1 -right-0.5 text-[13px] text-red-600" data-testid={`monthly-offsite-${sid}-${d.date.slice(8)}`}>*</span>}
        {d.sessions > 1 && <span className="absolute -bottom-1 -right-0.5 text-[9px] font-bold text-amber-700" data-testid={`monthly-sessions-${sid}-${d.date.slice(8)}`}>{d.sessions}</span>}
        {d.deployed_to && <span className="absolute -bottom-1 -left-0.5 text-[10px] text-indigo-600" data-testid={`monthly-deployed-${sid}-${d.date.slice(8)}`}>↗</span>}
      </div>
    </td>
  );
};

/** Staff × day grid for a month with per-staff totals. */
export const MonthlyGrid = ({ data }) => {
  const days = data.staff[0]?.days || [];
  return (
    <div className="overflow-x-auto rounded-xl bg-white shadow-md" data-testid="monthly-grid">
      <table className="text-sm border-separate border-spacing-0">
        <thead>
          <tr className="text-[11px] text-gray-500">
            <th className="sticky left-0 z-10 bg-white text-left px-3 py-2 min-w-[190px]">Staff</th>
            {days.map((d) => {
              const wd = new Date(`${d.date}T00:00:00`).getDay();
              return <th key={d.date} className={`px-0.5 py-1 font-medium ${wd === 0 ? 'text-red-500' : ''}`}><div>{Number(d.date.slice(8))}</div><div className="font-normal">{WD[wd]}</div></th>;
            })}
            {TOTALS.map(([k, l]) => <th key={k} className="px-2 py-2 bg-amber-50 text-amber-900">{l}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.staff.map((r) => (
            <tr key={r.staff_id} className="border-t" data-testid={`monthly-row-${r.staff_id}`}>
              <td className="sticky left-0 z-10 bg-white px-3 py-1.5 border-t">
                <div className="font-semibold leading-tight">{r.staff_name}</div>
                <div className="text-[11px] text-gray-500">{r.staff_linked === false ? 'No Staff ID' : r.staff_id} · {r.section}</div>
                <div className="text-[10px] text-gray-400">{r.worker_type ? `${r.worker_type[0].toUpperCase()}${r.worker_type.slice(1)} · ` : ''}{r.shift}</div>
              </td>
              {r.days.map((d) => <Cell key={d.date} d={d} sid={r.staff_id} />)}
              {TOTALS.map(([k]) => <td key={k} className="px-2 text-center font-mono bg-amber-50/60 border-t" data-testid={`monthly-total-${k}-${r.staff_id}`}>{r[k]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MonthlyGrid;
